import { $getRoot, $isTextNode } from "lexical";
import { $isHeadingNode } from "@lexical/rich-text";
import { $isListNode, $isListItemNode } from "@lexical/list";
import jsPDF from "jspdf";

export function getNotesAsText(editor: any): string {
  let text = "";
  
  editor.getEditorState().read(() => {
    const root = $getRoot();
    text = root.getTextContent();
  });
  
  return text;
}

export function getNotesAsHTML(editor: any): string {
  let html = "";
  
  editor.getEditorState().read(() => {
    const root = $getRoot();
    const children = root.getChildren();
    
    children.forEach((node) => {
      if ($isHeadingNode(node)) {
        const tag = node.getTag();
        const text = node.getTextContent();
        html += `<${tag}>${text}</${tag}>`;
      } else if ($isListNode(node)) {
        const tag = node.getListType() === "bullet" ? "ul" : "ol";
        html += `<${tag}>`;
        node.getChildren().forEach((listItem) => {
          if ($isListItemNode(listItem)) {
            html += `<li>${listItem.getTextContent()}</li>`;
          }
        });
        html += `</${tag}>`;
      } else if ($isTextNode(node)) {
        html += `<p>${node.getTextContent()}</p>`;
      } else {
        html += `<p>${node.getTextContent()}</p>`;
      }
    });
  });
  
  return html || "<p>No content</p>";
}

export async function exportNotesAsPDF(editor: any): Promise<void> {
  const text = getNotesAsText(editor);
  
  if (!text.trim()) {
    throw new Error("No content to export");
  }

  const pdf = new jsPDF();
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 20;
  const maxWidth = pageWidth - 2 * margin;
  
  // Split text into lines that fit the page width
  const lines = pdf.splitTextToSize(text, maxWidth);
  
  let y = margin;
  const lineHeight = 7;
  const pageHeight = pdf.internal.pageSize.getHeight();
  
  lines.forEach((line: string) => {
    if (y + lineHeight > pageHeight - margin) {
      pdf.addPage();
      y = margin;
    }
    pdf.text(line, margin, y);
    y += lineHeight;
  });
  
  pdf.save("notes.pdf");
}
